/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { CircularProgress } from '@mui/material';
import DefaultModal from './DefaultModal';
import Styles from '../../css/LoadingModal.module.css';
import { isStrEmptyOrNull } from '../../common/UtilityFunctions';

type loadingModalProps = {
  open: boolean;
  loadingMessage?: string;
};

const LoadingModal = (props: loadingModalProps) => {
  return (
    <DefaultModal
      className={Styles.section}
      open={props.open}
      title={
        <h1 className={Styles.loadingMessage}>
          {isStrEmptyOrNull(props.loadingMessage) ? 'Loading...' : props.loadingMessage}
        </h1>
      }
      content={<CircularProgress className={Styles.loadingSymbol} size={50} />}
    />
  );
};

export default LoadingModal;
